import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportcabs() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Airport Cab',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Airport Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and punctual Pune to Mumbai Airport cab services, ensuring a smooth and stress-free transfer to both Terminal 1 (Domestic) and Terminal 2 (International) airports. Our fleet of clean, air-conditioned Sedan, SUV, and Premium cars provides maximum comfort and convenience for individuals, families, and corporate travelers. With professional and background-verified chauffeurs, we guarantee safe driving, on-time pickups, and courteous service at all hours. Whether it’s an early morning flight or a late-night arrival, Sai Trupti Cabs ensures a seamless travel experience with transparent pricing, 24×7 support, and doorstep pickup from anywhere in Pune. Travel to Mumbai Airport in total comfort and peace of mind with Sai Trupti Cabs — your trusted travel partner for airport transfers.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



 "services": [
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Pune to Mumbai Airport Cab offers dependable and timely cab services for travelers heading to or from Mumbai Airport. With comfortable vehicles and skilled chauffeurs, it ensures safe and stress-free airport transfers at affordable prices."
  },
  {
    "name": "Pune to Mumbai Airport Taxi",
    "description": "Pune to Mumbai Airport Taxi provides convenient airport transfers between Pune and Mumbai. This service guarantees punctual pickups, professional drivers, and clean vehicles for a comfortable and hassle-free ride to your destination."
  },
  {
    "name": "Pune to Mumbai Airport Car Hire",
    "description": "Pune to Mumbai Airport Car Hire offers a range of cars from economy to premium models for travelers seeking flexibility and comfort. Whether for business or leisure, this service ensures smooth airport transfers with reliable drivers."
  },
  {
    "name": "Pune to Mumbai Airport Transfer Service",
    "description": "Pune to Mumbai Airport Transfer Service specializes in providing seamless transportation between Pune and Mumbai Airport. Featuring modern vehicles, courteous drivers, and 24/7 availability, it guarantees a safe and convenient journey."
  },
  {
    "name": "Pune to Mumbai Airport Drop",
    "description": "Pune to Mumbai Airport Drop service focuses on one-way transfers to the airport. Offering prompt pickups, comfortable rides, and experienced drivers, it ensures travelers reach Mumbai Airport on time and without stress."
  },
  {
    "name": "Pune to Mumbai Airport Innova Cab",
    "description": "Pune to Mumbai Airport Innova Cab provides spacious and comfortable Toyota Innovas ideal for family or group travel. With ample luggage space and air conditioning, this service ensures a relaxed and enjoyable airport transfer."
  },
  {
    "name": "Pune to Mumbai Airport Sedan",
    "description": "Pune to Mumbai Airport Sedan offers premium sedans for travelers seeking a smooth and comfortable ride. Perfect for executives and small families, these vehicles combine elegance, efficiency, and affordability for airport journeys."
  },
  {
    "name": "Pune to Mumbai Airport Ertiga",
    "description": "Pune to Mumbai Airport Ertiga service features Maruti Ertiga vehicles designed for group travel. Spacious interiors, clean seating, and skilled drivers ensure a comfortable and affordable airport transfer experience."
  },
  {
    "name": "Affordable Pune to Mumbai Airport Taxi",
    "description": "Affordable Pune to Mumbai Airport Taxi provides budget-friendly airport transfers without compromising on quality. It’s a popular choice for cost-conscious travelers looking for reliable service, punctuality, and comfortable cabs."
  },
  {
    "name": "Pune to Mumbai Airport Luxury Cab",
    "description": "Pune to Mumbai Airport Luxury Cab offers high-end vehicles for a premium travel experience. Perfect for VIPs and corporate clients, the service includes luxury sedans and SUVs driven by professional chauffeurs ensuring top comfort."
  },
  {
    "name": "Pune to Mumbai Airport Outstation Taxi",
    "description": "Pune to Mumbai Airport Outstation Taxi provides long-distance cab services connecting Pune to Mumbai Airport. It ensures safe travel with experienced drivers and well-maintained vehicles suitable for intercity transfers."
  },
  {
    "name": "Pune to Mumbai Airport 24x7 Service",
    "description": "Pune to Mumbai Airport 24x7 Service offers round-the-clock availability for airport transfers. No matter the time of day, passengers can rely on prompt service, clean cars, and courteous drivers for their travel needs."
  },
  {
    "name": "Pune to Mumbai Airport Online Booking",
    "description": "Pune to Mumbai Airport Online Booking makes scheduling rides quick and easy through an online platform. Customers can book instantly, choose vehicle types, and receive transparent fare details for their airport trips."
  },
  {
    "name": "Pune to Mumbai Airport Cab Fare",
    "description": "Pune to Mumbai Airport Cab Fare provides clear and upfront pricing for travelers. Offering affordable rates with no hidden charges, this service ensures customers enjoy fair pricing for their comfortable airport transfers."
  },
  {
    "name": "Pune to Mumbai Airport Taxi near Me",
    "description": "Pune to Mumbai Airport Taxi near Me ensures quick cab availability close to your location. It offers fast booking, professional drivers, and safe vehicles for convenient airport transfers anytime from anywhere in Pune."
  }
],
"tableData": [
  ["Pune to Mumbai Airport Cab", "Pune to Mumbai Airport Taxi"],
  ["Pune to Mumbai Airport Car Hire", "Pune to Mumbai Airport Transfer Service"],
  ["Pune to Mumbai Airport Drop", "Pune to Mumbai Airport Innova Cab"],
  ["Pune to Mumbai Airport Sedan", "Pune to Mumbai Airport Ertiga"],
  ["Affordable Pune to Mumbai Airport Taxi", "Pune to Mumbai Airport Luxury Cab"],
  ["Pune to Mumbai Airport Outstation Taxi", "Pune to Mumbai Airport 24x7 Service"],
  ["Pune to Mumbai Airport Online Booking", "Pune to Mumbai Airport Cab Fare"],
  ["Pune to Mumbai Airport Taxi near Me", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Airport Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Pune to Mumbai Airport, ensuring timely and stress-free transfers for business and leisure travelers."
  },
  {
    "WhyChooseheading": "Variety of Cabs for Every Need",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or luxury cars based on your group size, luggage, and travel preferences."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our drivers are courteous, punctual, and familiar with the fastest routes to Mumbai Airport, ensuring a smooth and safe journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Get affordable rates with no hidden charges, so you can plan your airport transfer with peace of mind."
  },
  {
    "WhyChooseheading": "On-Time Pickups and Airport Drop-offs",
    "WhyChoosedescription": "We guarantee timely pickups and drop-offs, helping you catch your flight without any hassle or delay."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "All our cabs are well-maintained, sanitized, and equipped for a relaxing ride to the airport."
  },
  {
    "WhyChooseheading": "24/7 Booking and Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round the clock to assist with bookings, flight schedule adjustments, and route planning."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Mumbai Airport cab easily via call, WhatsApp, or our website, with instant confirmation and prompt vehicle dispatch."
  }
]




























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  provide Pune to Mumbai Airport cab services?',
    answer: 'Yes, Sai Trupti Cabs  offers reliable and affordable Pune to Mumbai Airport cab services for one-way and round trips.',
  },
  {
    question: 'How can I book a Pune to Mumbai Airport cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Mumbai Airport cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for the Pune to Mumbai Airport route?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to match your travel comfort and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Mumbai Airport routes?',
    answer: 'Yes, our drivers are highly experienced and familiar with the Pune–Mumbai Expressway, ensuring a safe and timely airport drop.',
  },
  {
    question: 'Can I schedule a Pune to Mumbai Airport cab in advance?',
    answer: 'Absolutely. You can pre-book your cab in advance to ensure on-time pickup and hassle-free airport transfers.',
  },
  {
    question: 'Is the Pune to Mumbai Airport cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs provides 24×7 cab services from Pune to Mumbai Airport for early morning or late-night flights.',
  },
  {
    question: 'What safety and hygiene measures are followed during the trip?',
    answer: 'All vehicles are cleaned and sanitized before every ride, and drivers follow all safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Pune to Mumbai Airport cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, net banking, and digital wallets for your convenience.',
  },
  {
    question: 'Is customer support available during the Pune to Mumbai Airport cab journey?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pune to Mumbai Airport transfer.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aniket Joshi',
    feedback: 'Sai Trupti Cabs made my Pune to Mumbai Airport trip stress-free. The driver was punctual and courteous, and the ride was comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rutuja Deshmukh',
    feedback: 'Excellent Pune to Mumbai Airport cab service by Sai Trupti Cabs. Clean car, smooth drive, and timely drop at the terminal!',
    rating: 5,
  },
];





















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-airport-cab.jpg",
  "description": "Book Pune to Mumbai Airport Cab with Sai Trupti Cabs for a safe, fast, and affordable airport transfer. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or drop service. 24/7 booking and professional drivers ensure on-time pickup and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15987"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2599",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-airport-cab"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Airport Cab | On-Time & Affordable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Airport Cab with Sai Trupti Cabs for a safe, fast, and affordable airport transfer. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or drop service. 24/7 booking and professional drivers ensure on-time pickup and comfortable travel." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Airport Cab, Pune to Mumbai Airport Taxi, Pune to Mumbai Airport Car Hire, Pune to Mumbai Airport Transfer Service, Pune to Mumbai Airport Drop, Pune to Mumbai Airport Innova Cab, Pune to Mumbai Airport Sedan, Pune to Mumbai Airport Ertiga, Affordable Pune to Mumbai Airport Taxi, Pune to Mumbai Airport Luxury Cab, Pune to Mumbai Airport Outstation Taxi, Pune to Mumbai Airport 24x7 Service, Pune to Mumbai Airport Online Booking, Pune to Mumbai Airport Cab Fare, Pune to Mumbai Airport Taxi near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiairportcabs;